export default "__VITE_ASSET__EI7mOjyY__"